namespace Gamification.Gamification {
    export interface UtentiProdottiAlertForm {
        IdUtenteProdotto: Serenity.IntegerEditor;
        IdRaccomandazione: Serenity.IntegerEditor;
        Nome: Serenity.StringEditor;
        Messaggio: Serenity.TextAreaEditor;
        DataOra: Serenity.DateTimeEditor;
    }

    export class UtentiProdottiAlertForm extends Serenity.PrefixedContext {
        static formKey = 'Gamification.UtentiProdottiAlert';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!UtentiProdottiAlertForm.init)  {
                UtentiProdottiAlertForm.init = true;

                var s = Serenity;
                var w0 = s.IntegerEditor;
                var w1 = s.StringEditor;
                var w2 = s.TextAreaEditor;
                var w3 = s.DateTimeEditor;

                Q.initFormType(UtentiProdottiAlertForm, [
                    'IdUtenteProdotto', w0,
                    'IdRaccomandazione', w0,
                    'Nome', w1,
                    'Messaggio', w2,
                    'DataOra', w3
                ]);
            }
        }
    }
}
